import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { APP_NAME } from '../mock/data';

// ---- PDF export helper (table style report) ----
export function exportPDF(filename, title, columns, rows, sections = []) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const gold = [217, 179, 74];

  doc.setFontSize(16);
  doc.setTextColor(30, 30, 30);
  doc.text(APP_NAME, 40, 40);

  doc.setFontSize(11);
  doc.setTextColor(120, 120, 120);
  doc.text(title, 40, 58);
  doc.text(`Generated: ${new Date().toLocaleString()}`, 40, 74);

  autoTable(doc, {
    startY: 90,
    head: [columns.map((c) => c.label)],
    body: rows.map((row) => columns.map((c) => String(c.get(row) ?? ''))),
    styles: { fontSize: 8, cellPadding: 5, overflow: 'linebreak' },
    headStyles: { fillColor: gold, textColor: [23, 20, 10], fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    margin: { left: 40, right: 40 },
  });

  sections.forEach((s) => {
    let y = (doc.lastAutoTable?.finalY || 90) + 28;
    if (s.heading) {
      doc.setFontSize(11);
      doc.setTextColor(60, 60, 60);
      doc.text(s.heading, 40, y);
      y += 10;
    }
    autoTable(doc, {
      startY: y,
      head: [s.columns.map((c) => c.label)],
      body: s.rows.map((row) => s.columns.map((c) => String(c.get(row) ?? ''))),
      styles: { fontSize: 8, cellPadding: 5, overflow: 'linebreak' },
      headStyles: { fillColor: gold, textColor: [23, 20, 10], fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { left: 40, right: 40 },
    });
  });

  doc.save(filename);
}
